// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-to-top{background-color:#de3131!important;color:#fff;padding:1rem!important;box-shadow:none!important}", ""]);
// Exports
module.exports = exports;
